module.exports = __webpack_public_path__ + "img/2B2B22_3C3C30_464538_121210-256px.14f22286.png";